import styled from '@emotion/styled'

import { Header, Paragraph } from 'components/patterns/Typography'
import { DrawerDivider } from 'components/patterns'

import CardList from 'components/CardList'
import { CardContent } from 'components/Card/Card.style'

const cardContentAdjustment = `
  ${CardContent} {
    display: flex;
    padding: 10px 20px;
    width: 100%;
  }
`
export const HistoryListHeader = styled(Header)`
  margin: 0 20px 10px 20px;
  svg {
    margin-right: 5px;
    margin-bottom: 1px;
  }
`
export const HistoryList = styled(CardList)`
  border-left: none;
  border-right: none;
  ${cardContentAdjustment}
`
export const HistoryDivider = styled(DrawerDivider)`
  margin: 0;
`
export const NoHistoryFound = styled(Paragraph)`
  text-align: center;
  margin-top: 30px;
`

export const DrawerWrapper = styled.div`
  margin: 0 -20px;
`
